import {rootState} from '@mintdata-wsp/common/state/RootState';
import {SurfaceMovingState} from '@mintdata-wsp/common/state/ui/visualDesigner/SurfaceEditorState';
import {action} from 'mobx';

export class SurfaceMovingController
{
    @action
    public setDragStartX(dragStartX:number)
    {
        this._getState().dragStartX = dragStartX;
    }

    @action
    public setDragStartY(dragStartY:number)
    {
        this._getState().dragStartY = dragStartY;
    }

    @action
    public setDragDeltaX(dragDeltaX:number)
    {
        this._getState().dragDeltaX = dragDeltaX;
    }

    @action
    public setDragDeltaY(dragDeltaY:number)
    {
        this._getState().dragDeltaY = dragDeltaY;
    }

    @action
    public setDrag(dragStartX:number = null,
                   dragStartY:number = null,
                   dragDeltaX:number = null,
                   dragDeltaY:number = null)
    {
        const state:SurfaceMovingState = this._getState();

        if( dragStartX !== null )
            state.dragStartX = dragStartX;

        if( dragStartY !== null )
            state.dragStartY = dragStartY;

        if( dragDeltaX !== null )
            state.dragDeltaX = dragDeltaX;

        if( dragDeltaY !== null )
            state.dragDeltaY = dragDeltaY;
    }

    @action
    public setBoxDragStartX(dragStartX:number)
    {
        this._getState().boxDragStartX = dragStartX;
    }

    @action
    public setBoxDragStartY(dragStartY:number)
    {
        this._getState().boxDragStartY = dragStartY;
    }

    @action
    public setBoxDragDeltaX(dragDeltaX:number)
    {
        this._getState().boxDragDeltaX = dragDeltaX;
    }

    @action
    public setBoxDragDeltaY(dragDeltaY:number)
    {
        this._getState().boxDragDeltaY = dragDeltaY;
    }

    @action
    public setBoxDrag(dragStartX:number = null,
                      dragStartY:number = null,
                      dragDeltaX:number = null,
                      dragDeltaY:number = null)
    {
        const state:SurfaceMovingState = this._getState();

        if( dragStartX !== null )
            state.boxDragStartX = dragStartX;

        if( dragStartY !== null )
            state.boxDragStartY = dragStartY;

        if( dragDeltaX !== null )
            state.boxDragDeltaX = dragDeltaX;

        if( dragDeltaY !== null )
            state.boxDragDeltaY = dragDeltaY;
    }

    public getDragStartX():number
    {
        return this._getState().dragStartX;
    }

    public getDragStartY():number
    {
        return this._getState().dragStartY;
    }

    public getDragDeltaX():number
    {
        return this._getState().dragDeltaX;
    }

    public getDragDeltaY():number
    {
        return this._getState().dragDeltaY;
    }

    public getDrag():{dragStartX:number, dragStartY:number, dragDeltaX:number, dragDeltaY:number}
    {
        const state:SurfaceMovingState = this._getState();

        return {
            dragStartX: state.dragStartX,
            dragStartY: state.dragStartY,
            dragDeltaX: state.dragDeltaX,
            dragDeltaY: state.dragDeltaY
        };
    }

    public getBoxDragStartX():number
    {
        return this._getState().boxDragStartX;
    }

    public getBoxDragStartY():number
    {
        return this._getState().boxDragStartY;
    }

    public getBoxDragDeltaX():number
    {
        return this._getState().boxDragDeltaX;
    }

    public getBoxDragDeltaY():number
    {
        return this._getState().boxDragDeltaY;
    }

    public getBoxDrag():{boxDragStartX:number, boxDragStartY:number, boxDragDeltaX:number, boxDragDeltaY:number}
    {
        const state:SurfaceMovingState = this._getState();

        return {
            boxDragStartX: state.boxDragStartX,
            boxDragStartY: state.boxDragStartY,
            boxDragDeltaX: state.boxDragDeltaX,
            boxDragDeltaY: state.boxDragDeltaY
        };
    }

    public _getState():SurfaceMovingState
    {
        return rootState.ui.visualDesigner.surfaceEditor.area.surfaceMovingState;
    }
}
